export default __webpack_public_path__ + "static/media/unread.2427d740.svg";